var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"emptyBox"},[_c('img',{attrs:{"src":require("../assets/image/empty.png"),"alt":""}}),_c('span',[_c('strong',[_vm._v("很抱歉，")]),_vm._v("\n    "+_vm._s(_vm.moreTxt)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }